import React, { useMemo } from 'react';
import classNames from 'classnames';

import styles from '../assets/css/booking.module.css';

const LuggageCategory = ({ totals, list, passenger, toggleBagSelect, currency }) => (
  <div className={classNames(styles.container, styles.input_container)}>
    <div className="luggage-input-container">
      <div className="allowedLuggage">
        {list.map((bag, index) => {
          const nextItems = list.filter((_, i) => i > index);
          const prevItems = list.filter((_, i) => i < index);
          const disabled = (!bag.isSelected && prevItems.some(item => !item.selected))
            || (bag.isSelected && nextItems.some(item => item.selected));

          return (
            <>
              <div
                className={bag.isSelected ? 'luggage-box selected-luggage' : 'luggage-box'}
                onClick={() => toggleBagSelect(bag, passenger)} disabled={disabled}>
                <div>
                  <div className='luggage-weight'>
                    <span className="iconify" data-icon="ic:round-luggage"></span>
                    <p>حقيبة وزن {bag.weight} كغم </p>
                  </div>
                  <strong className='luggage-price'>{!Number(bag.price) ? 'مجانية' : `${bag.price} ${currency}`}</strong>
                </div>

              </div>
            </>
          );
        })
        }
      </div>

      <div className="total">
        <p>{totals.weight} كغم</p>
        <p> {totals.price} {currency}</p>
      </div>
    </div>
  </div>
);

const LuggageInput = ({
  currency,
  toggleBagSelect,
  passenger,
  passenger: { baggage, extraBaggage: { hold: holdList = [], carryOn: carryOnList = [] } = {} } = {},
}) => {
  const calculateTotals = (list) => list.reduce((acc, { price, weight, isSelected }) => ({
    ...acc,
    price: isSelected ? acc.price + Number(price) : acc.price,
    weight: isSelected ? acc.weight + weight : acc.weight
  }), { price: 0, weight: 0 });

  const holdTotals = useMemo(() => calculateTotals(holdList), [holdList]);
  const carryOnTotals = useMemo(() => calculateTotals(carryOnList), [carryOnList]);

  return (
    <>
      {
        holdList.length > 0 &&
        <LuggageCategory
          list={holdList}
          totals={holdTotals}
          passenger={passenger}
          toggleBagSelect={toggleBagSelect}
          currency={currency}
        />
      }

      {
        carryOnList.length > 0 &&
        <LuggageCategory
          list={carryOnList}
          totals={carryOnTotals}
          passenger={passenger}
          toggleBagSelect={toggleBagSelect}
          currency={currency}
        />
      }
    </>
  );
};

export default LuggageInput;